import InvestorGoalError from './InvestorGoalError';
class AccountValueMustBeANumber extends InvestorGoalError {
    constructor(options) {
        super('The account value must be a number', options);
    }
}
export default AccountValueMustBeANumber;
